import { useMemo } from "react";
import { Button, Space, Tag, Tooltip, Popconfirm, Input } from "antd";
import Settings from "../../dependencies/custom/settings";
import Utilities from "../../dependencies/custom/react-utilities";
import CustomFunctions from "../../dependencies/custom/custom-functions";
import ValuesStore from "../../store/values-store";
import dayjs from "dayjs";
const { TextArea } = Input;

// import { useState } from "react";
function actions(
  del,
  delUrl,
  editUrl,
  delIdKey,
  onEdit,
  onDelete,
  setRerender,
  perms,
) {
  // console.log(editUrl,perms)
  return {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        {Utilities.hasPermissionV2(["POST", "PUT", "PATCH"], perms, editUrl) ? (
          <Button
            className="btn-success border-0"
            onClick={(e) => {
              onEdit(record);
              setRerender((v) => !v);
            }}
            icon={<i className="fas fa-edit" />}
          >
            Edit
          </Button>
        ) : (
          ""
        )}
        {Utilities.hasPermissionV2(["DELETE"], perms, delUrl)
          ? del.confirm(
              `${delUrl}/${record?.[delIdKey]}`,
              {},
              "Deleting this record?",
              "DELETE",
              <Button
                className="btn-danger border-0"
                icon={<i className="fas fa-trash" />}
              >
                {" "}
                Delete
              </Button>,
              undefined,
              undefined,
              undefined,
              onDelete,
            )
          : ""}
      </Space>
    ),
  };
}

function printCoupon(pdfExport) {
  return {
    title: "Print",
    key: "print",
    render: (_, record) => (
      <Button
        disabled={record?.couponCode ? false : true}
        type="primary"
        className=""
        onClick={(e) =>
          CustomFunctions.printCoupon(record, pdfExport)
        } /*icon={<i className='fas fa-print' />}*/
      >
        <i className="fas fa-print" />
      </Button>
    ),
  };
}

function printRepairJobCard(pdfExport) {
  return {
    title: "Print",
    key: "print",
    render: (_, record) => (
      <Tooltip title="Print">
        <Button
          disabled={record?.status == "Approved" ? false : true}
          type="primary"
          className=""
          onClick={(e) =>
            CustomFunctions.printRepairJobCard(record, pdfExport)
          } /*icon={<i className='fas fa-print' />}*/
        >
          <i className="fas fa-print" />
        </Button>
      </Tooltip>
    ),
  };
}
function upload(navigate, title) {
  return {
    title: "Upload",
    key: "upload",
    render: (_, record) => (
      <Tooltip title={title}>
        <Button
          type="dashed"
          className=""
          onClick={(e) =>
            navigate(`../admin/upload`, { state: { id: record?.id } })
          }
        >
          <i className="fas fa-upload text-success" />
        </Button>
        {/* <Button disabled={record?.status == 'Approved' && !record?.hasUpload ? false : true} type='dashed' className='' onClick={e => navigate(`../admin/upload`, { state: { id: record?.id } })}>
                    <i className='fas fa-upload text-success' />
                </Button> */}
      </Tooltip>
    ),
  };
}

function apprvDeclActions(
  table,
  endpoint,
  navigate,
  setRecord,
  postRequestKey = "fuelRequestID",
  postValueKey = "id",
  rejectionRemark,
  perms,
) {
  return {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Popconfirm
          title="Please confirm action"
          description="This action cannot be undone"
          onConfirm={(e) =>
            CustomFunctions.changeStatus(
              table,
              endpoint,
              record,
              Settings.RequestsActions.Approved,
              navigate,
              setRecord,
              postRequestKey,
              postValueKey,
              rejectionRemark,
            )
          }
          okText="Ok"
          cancelText="Cancel"
        >
          <Button
            className="btn-success border-0"
            icon={<i className="far fa-thumbs-up" />}
          >
            Approve
          </Button>
        </Popconfirm>
        <Popconfirm
          title="Confirm rejection with remarks"
          description={
            <TextArea
              ref={rejectionRemark}
              placeholder="Reason for rejection"
              autoSize
            />
          }
          onConfirm={(e) =>
            CustomFunctions.changeStatus(
              table,
              endpoint,
              record,
              Settings.RequestsActions.Rejected,
              navigate,
              setRecord,
              postRequestKey,
              postValueKey,
              rejectionRemark,
            )
          }
          okText="Ok"
          cancelText="Cancel"
        >
          <Button
            className="btn-danger border-0"
            icon={<i className="far fa-thumbs-down" />}
          >
            Decline
          </Button>
        </Popconfirm>
      </Space>
    ),
  };
}

function viewAction(table, endpoint, navigate, id, setRecord, perms) {
  return {
    title: "View",
    key: "view",
    render: (_, row) => (
      <Space size="middle">
        <Button
          className="btn-primary border-0"
          onClick={(e) =>
            CustomFunctions.getRecordDetails(
              endpoint,
              row,
              id,
              navigate,
              setRecord,
            )
          }
          icon={<i className="far fa-eye" />}
        >
          Details
        </Button>
      </Space>
    ),
  };
}

function maintRequestColumns(table) {
  return [
    {
      title: "Number",
      dataIndex: "maintenanceRequestNumber",
      ...table?.getColumnSearchProps("maintenanceRequestNumber"),
    },
    {
      title: "Bus Number",
      dataIndex: "busPlateNumber",
      ...table?.getColumnSearchProps("busPlateNumber"),
    },
    {
      title: "Type",
      dataIndex: "maintenanceType",
      ...table?.getColumnSearchProps("maintenanceType"),
    },
    {
      title: "Title",
      dataIndex: "issue",
      ...table?.getColumnSearchProps("issue"),
    },
    {
      title: `Driver's Name`,
      dataIndex: "driverName",
      ...table?.getColumnSearchProps("driverName"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render(v, record) {
        return v == "Approved" ? (
          <Tag color="blue">{v}</Tag>
        ) : v == "Completed" ? (
          <Tag color="green">{v}</Tag>
        ) : v == "Rejected" ? (
          <Tag color="red">{v}</Tag>
        ) : (
          <Tag color="indigo">{v}</Tag>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      ...table?.getColumnSearchProps("createdAt"),
      render(v, record) {
        return Utilities.formatDate(v);
      },
    },
  ]?.filter(Boolean);
}

function fuelRequestColumns(table) {
  return [
    {
      title: "Number",
      dataIndex: "requestNumber",
      ...table?.getColumnSearchProps("requestNumber"),
    },
    {
      title: "Coupon Code",
      dataIndex: "couponCode",
      ...table?.getColumnSearchProps("couponCode"),
    },
    {
      title: `Driver's Name`,
      dataIndex: "driverName",
      ...table?.getColumnSearchProps("driverName"),
    },
    {
      title: "Litres",
      dataIndex: "requestLitres",
    },
    // {
    //     title: 'Purpose',
    //     dataIndex: 'purpose',
    // },
    {
      title: "Status",
      dataIndex: "status",
      render(v, record) {
        return v == "Rejected" ? (
          <Tag color="red">{v}</Tag>
        ) : v == "Coupon Generated" ? (
          <Tag color="green">{v}</Tag>
        ) : (
          <Tag color="blue">{v}</Tag>
        );
      },
    },
    {
      title: "Exceptional",
      dataIndex: "exceptional",
      filters: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
      onFilter: (v, record) => {
        return record.exceptional == v;
      },
      render(v, record) {
        return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      ...table?.getColumnSearchProps("date"),
    },
  ]?.filter(Boolean);
}

function subjectAssignmentColumns(
  table,
  navigate,
  setItemToview,
  readOnly = true,
  showDetails = true,
) {
  return [
    {
      title: "Class",
      dataIndex: "className",
      ...table?.getColumnSearchProps("className"),
    },
    {
      title: "Teacher",
      dataIndex: "teacherName",
      ...table?.getColumnSearchProps("teacherName"),
    },
    {
      title: "Subject",
      dataIndex: "subjectName",
      ...table?.getColumnSearchProps("subjectName"),
    },
    {
      title: "Stream",
      dataIndex: "streamName",
      ...table?.getColumnSearchProps("streamName"),
    },
    {
      title: "Academic Year",
      dataIndex: "academicYear",
      ...table?.getColumnSearchProps("academicYear"),
    },
    {
      title: "Term",
      dataIndex: "term",
      ...table?.getColumnSearchProps("term"),
    },
    {
      title: "Status",
      dataIndex: "status",
      ...table?.getColumnSearchProps("status"),
      render(v, record) {
        return v?.toLowerCase() == "submitted" ? (
          <Tag color="green">{v}</Tag>
        ) : (
          <Tag color="blue">{v}</Tag>
        );
      },
      // title: 'Status',
      // dataIndex: 'status',
      // ...table?.getColumnSearchProps('status'),
    },
    showDetails && {
      title: "Details",
      key: "details",
      render: (_, row) => (
        <Space size="middle">
          <Button
            className="btn-primary border-0"
            onClick={(e) =>
              CustomFunctions.viewSubjectAssignment(
                navigate,
                "id",
                setItemToview,
                row,
                readOnly,
              )
            }
            icon={<i className="far fa-eye" />}
          >
            Details
          </Button>
        </Space>
      ),
    },
    {
      title: "Attendance",
      key: "attendance",
      render: (_, row) => (
        <Space size="middle">
          <Button
            className="btn-success border-0"
            onClick={(e) =>
              CustomFunctions.studentAttendance(
                navigate,
                "id",
                setItemToview,
                row,
              )
            }
            icon={<i className="fas fa-clock" />}
          >
            Attendance
          </Button>
        </Space>
      ),
    },
  ]?.filter(Boolean);
}

const SetupObject = (
  table,
  del,
  onEdit,
  onDelete,
  pdfExport,
  navigate,
  setRerender,
  setItemToview,
  valuesStore,
  perms,
  extras = {},
) => {
  const _myRoles =
    valuesStore?.["myRoles"] ||
    JSON.parse(sessionStorage.getItem("myRoles") || "[]");
  const _isSystemAdmin =
    Array.isArray(_myRoles) && _myRoles.includes("System Administrator");

  return {
    //ATTENDANCE REMARKS
    ATTENDANCE_REMARKS: {
      label: "Attendance Remarks",
      tableName: "ATTENDANCE_REMARKS",
      columns: [
        {
          title: "Remark",
          dataIndex: "remark",
          ...table.getColumnSearchProps("remark"),
        },
        actions(
          del,
          Settings.urls.academics.attendance_remark,
          Settings.urls.academics.attendance_remark,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },
    //PRESCHOOL LEARNING AREAS
    PRESCHOOL_LEARNING_AREAS: {
      label: "Preschool Learning Areas",
      tableName: "PRESCHOOL_LEARNING_AREAS",
      columns: [
        {
          title: "Area",
          dataIndex: "columnName",
          ...table.getColumnSearchProps("columnName"),
        },
        actions(
          del,
          Settings.urls.academics.preschool_learning_areas,
          Settings.urls.academics.preschool_learning_areas,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //PRESCHOOL GRADESS
    PRESCHOOL_GRADES: {
      label: "Preschool Grades",
      tableName: "PRESCHOOL_GRADES",
      columns: [
        {
          title: "Grade",
          dataIndex: "letterGrade",
          ...table.getColumnSearchProps("letterGrade"),
        },
        {
          title: "Remark",
          dataIndex: "remark",
          ...table.getColumnSearchProps("remark"),
        },
        actions(
          del,
          Settings.urls.academics.preschool_grades,
          Settings.urls.academics.preschool_grades,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //ACCOMMODATION
    ACCOMMODATION: {
      label: "Houses and Dormitories",
      tableName: "ACCOMMODATION",
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          ...table.getColumnSearchProps("name"),
        },
        {
          title: "Category",
          dataIndex: "category",
          filters: [
            { text: "House", value: "House" },
            { text: "Dormitory", value: "Dormitory" },
          ],
          onFilter: (value, record) => record.category === value,
        },
        {
          title: "Capacity",
          dataIndex: "capacity",
          ...table.getColumnSearchProps("capacity"),
        },
        {
          title: "Remainder",
          dataIndex: "remainingSpace",
          ...table.getColumnSearchProps("remainingSpace"),
        },
        actions(
          del,
          Settings.urls.enrollment.accommodation,
          Settings.urls.enrollment.accommodation,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //STUDENTS
    STUDENTS: {
      label: "Students",
      tableName: "STUDENTS",
      columns: [
        {
          title: "FIRSTNAME",
          dataIndex: "firstName",
          ...table.getColumnSearchProps("firstName"),
        },
        {
          title: "SURNAME",
          dataIndex: "lastName",
          ...table.getColumnSearchProps("lastName"),
        },
        {
          title: "OTHERNAMES",
          dataIndex: "middleName",
          ...table.getColumnSearchProps("middleName"),
        },
        {
          title: "DOB",
          dataIndex: "dob",
          render: (v, record) => {
            return dayjs(v.dob).format("DD/MM/YYYY");
          },
          ...table.getColumnSearchProps("dob"),
        },
        {
          title: "GENDER",
          dataIndex: "gender",
          ...table.getColumnSearchProps("gender"),
        },
        {
          title: "CLASS",
          dataIndex: "className",
          ...table.getColumnSearchProps("className"),
        },
        {
          title: "D/B",
          dataIndex: "dayBoarding",
          ...table.getColumnSearchProps("dayBoarding"),
        },
      ]?.filter(Boolean),
    },
    //ASSIGN SUBJECTS
    SUBJECT_ASSIGNMENTS: {
      label: "Assign Subjects",
      tableName: "SUBJECT_ASSIGNMENTS",
      columns: [
        ...subjectAssignmentColumns(table, navigate, setItemToview),
        actions(
          del,
          Settings.urls.academics.subject_assignments,
          Settings.urls.academics.subject_assignments,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },
    //MY SUBJECTS
    MY_ASSIGNMENTS: {
      label: "My Subjects",
      tableName: "MY_ASSIGNMENTS",
      columns: subjectAssignmentColumns(
        table,
        navigate,
        setItemToview,
        false,
        false,
      ),
    },
    //CLASS SUBJECTS MANAGEMENT
    CLASS_SUBJECTS: {
      label: "Class Management",
      tableName: "CLASS_MANAGEMENT",
      columns: subjectAssignmentColumns(table, navigate, setItemToview, false),
    },

    //USERS
    users: {
      label: "Users",
      tableName: "USERS",
      columns: [
        {
          title: "Email",
          dataIndex: "email",
          ...table?.getColumnSearchProps("email"),
        },
        {
          title: "Full Name",
          dataIndex: "fullName",
          ...table?.getColumnSearchProps("fullName"),
        },
        {
          title: "Staff ID",
          dataIndex: "staffId",
          ...table?.getColumnSearchProps("staffId"),
        },
        {
          title: "Country Code",
          dataIndex: "countryCode",
          ...table?.getColumnSearchProps("countryCode"),
        },
        {
          title: "Telephone",
          dataIndex: "phone",
          ...table?.getColumnSearchProps("phone"),
        },
        _isSystemAdmin
          ? {
              title: "Action",
              key: "action",
              render: (_, record) => (
                <Space size="middle">
                  {Utilities.hasPermissionV2(
                    ["POST", "PUT", "PATCH"],
                    perms,
                    Settings.urls.auth.adminSignup,
                  ) ? (
                    <Button
                      className="btn-success border-0"
                      onClick={(e) => {
                        onEdit(record);
                        setRerender((v) => !v);
                      }}
                      icon={<i className="fas fa-edit" />}
                    >
                      Edit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Popconfirm
                    title="Revoke staff access?"
                    description={`Remove staff privileges from ${record.fullName || record.email}?`}
                    onConfirm={() => extras?.onRevokeStaff?.(record)}
                    okText="Revoke"
                    cancelText="Cancel"
                    okButtonProps={{ danger: true }}
                  >
                    <Button
                      className="btn-warning border-0"
                      loading={!!extras?.staffRevoking?.[record.userID]}
                      icon={<i className="fas fa-user-times" />}
                    >
                      Revoke Staff
                    </Button>
                  </Popconfirm>
                  {Utilities.hasPermissionV2(
                    ["DELETE"],
                    perms,
                    Settings.urls.auth.adminSignup,
                  )
                    ? del.confirm(
                        `${Settings.urls.auth.adminSignup}/${record?.userID}`,
                        {},
                        "Deleting this record?",
                        "DELETE",
                        <Button
                          className="btn-danger border-0"
                          icon={<i className="fas fa-trash" />}
                        >
                          {" "}
                          Delete
                        </Button>,
                        undefined,
                        undefined,
                        undefined,
                        onDelete,
                      )
                    : ""}
                </Space>
              ),
            }
          : null,
      ]?.filter(Boolean),
    },

    //school classes
    klasses: {
      label: "Classes",
      tableName: "KLASSES",
      columns: [
        {
          title: "Class",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        {
          title: "Group",
          dataIndex: "classGroup",
          ...table?.getColumnSearchProps("classGroup"),
        },
        actions(
          del,
          Settings.urls.bootstrap.klass,
          Settings.urls.bootstrap.klass,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //streams
    stream: {
      label: "Streams",
      tableName: "STREAMS",
      columns: [
        {
          title: "Stream",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        actions(
          del,
          Settings.urls.bootstrap.stream,
          Settings.urls.bootstrap.stream,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //subjects
    subjects: {
      label: "Subjects",
      tableName: "SUBJECTS",
      columns: [
        {
          title: "Subject",
          dataIndex: "subject",
          ...table?.getColumnSearchProps("subject"),
        },
        {
          title: "Type",
          dataIndex: "subjectType",
          ...table?.getColumnSearchProps("subjectType"),
        },
        {
          title: "Category",
          dataIndex: "subjectCategory",
          render: (v) =>
            v ? (
              v === "Core" ? (
                <Tag color="blue">{v}</Tag>
              ) : (
                <Tag color="gold">{v}</Tag>
              )
            ) : (
              "-"
            ),
        },
        {
          title: "For Interview",
          dataIndex: "for_interview",
          // ...table?.getColumnSearchProps('group'),
        },
        actions(
          del,
          Settings.urls.bootstrap.subject,
          Settings.urls.bootstrap.subject,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //STATUSES
    statuses: {
      label: "Statuses",
      tableName: "STATUSES",
      columns: [
        {
          title: "Status",
          dataIndex: "status",
          ...table?.getColumnSearchProps("status"),
        },
        {
          title: "Lock Form",
          dataIndex: "lock_form",
          // ...table?.getColumnSearchProps('lock_form'),
        },
        {
          title: "Show Score Button",
          dataIndex: "show_score_btn",
          // ...table?.getColumnSearchProps('group'),
        },
        actions(
          del,
          Settings.urls.bootstrap.status,
          Settings.urls.bootstrap.status,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //STATUS TRANSITIONS
    klass_status_transitions: {
      label: "Status Transitions",
      tableName: "STATUS_TRANSITIONS",
      columns: [
        {
          title: "Class",
          dataIndex: "klass",
          ...table?.getColumnSearchProps("klass"),
        },
        {
          title: "Current Status",
          dataIndex: "current_status",
          ...table?.getColumnSearchProps("current_status"),
        },
        {
          title: "Change To",
          dataIndex: "can_change_to",
          ...table?.getColumnSearchProps("can_change_to"),
        },
        actions(
          del,
          Settings.urls.bootstrap.statusTransition,
          Settings.urls.bootstrap.statusTransition,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },
    //Nationality
    nationality: {
      label: "Nationality",
      tableName: "NATIONALITY",
      columns: [
        {
          title: "Country",
          dataIndex: "country",
          ...table?.getColumnSearchProps("country"),
        },
        {
          title: "Nationality",
          dataIndex: "nationality",
          ...table?.getColumnSearchProps("nationality"),
        },
        actions(
          del,
          Settings.urls.bootstrap.nations,
          Settings.urls.bootstrap.nations,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //Relationship
    relationship: {
      label: "Relationship",
      tableName: "RELATIONSHIP",
      columns: [
        {
          title: "Relationship",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        {
          title: "Blocked",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.bootstrap.relationship,
          Settings.urls.bootstrap.relationship,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //Roles
    roles: {
      label: "Roles",
      tableName: "ROLES",
      columns: [
        {
          title: "System Name",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        {
          title: "Real Name",
          dataIndex: "customName",
          ...table?.getColumnSearchProps("customName"),
        },
        {
          title: "Blocked",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Description",
          dataIndex: "description",
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.rbac.roles,
          Settings.urls.rbac.roles,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //Permissions
    permissions: {
      label: "Permissions",
      tableName: "PERMISSIONS",
      columns: [
        {
          title: "Name",
          dataIndex: "customName",
          ...table?.getColumnSearchProps("customName"),
        },
        {
          title: "Method",
          dataIndex: "method",
          ...table?.getColumnSearchProps("method"),
        },
        {
          title: "Path",
          dataIndex: "apiPath",
          ...table?.getColumnSearchProps("apiPath"),
        },
        {
          title: "Regex Path",
          dataIndex: "regexPath",
          ...table?.getColumnSearchProps("regexPath"),
        },
        {
          title: "Description",
          dataIndex: "description",
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Wildcard",
          dataIndex: "wildcard",
          // ...table?.getColumnSearchProps('wildcard'),
          render(v, record) {
            return v ? (
              <Tag color="success">Yes</Tag>
            ) : (
              <Tag color="red">No</Tag>
            );
          },
        },
        {
          title: "Active",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Open",
          dataIndex: "open",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
      ]?.filter(Boolean),
    },

    //Pages
    pages: {
      label: "Pages",
      tableName: "PAGES",
      columns: [
        {
          title: "Name",
          dataIndex: "customName",
          ...table?.getColumnSearchProps("customName"),
        },

        {
          title: "Route",
          dataIndex: "route",
          ...table?.getColumnSearchProps("route"),
        },
        {
          title: "Icon String",
          dataIndex: "icon",
          // ...table?.getColumnSearchProps('icon'),
        },
        {
          title: "Page Number",
          dataIndex: "order",
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Active",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Open",
          dataIndex: "open",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        // actions(del, Settings.urls.rbac.pages, Settings.urls.rbac.pages, 'id', onEdit, onDelete, setRerender),
      ]?.filter(Boolean),
    },

    //USER ROLES
    user_roles: {
      label: "Users & Roles",
      tableName: "USER_ROLES",
      columns: [
        {
          title: "User",
          dataIndex: "email",
          ...table?.getColumnSearchProps("email"),
        },

        {
          title: "Role",
          dataIndex: "roleName",
          ...table?.getColumnSearchProps("roleName"),
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Blocked",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.rbac.userRoles,
          Settings.urls.rbac.userRoles,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    // ROLE_PAGES
    role_pages: {
      label: "Roles & Pages",
      tableName: "ROLE_PAGES",
      columns: [
        {
          title: "Role",
          dataIndex: "roleName",
          ...table?.getColumnSearchProps("roleName"),
        },

        {
          title: "Page",
          dataIndex: "pageCustomName",
          ...table?.getColumnSearchProps("pageCustomName"),
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Active",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Open",
          dataIndex: "open",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.rbac.rolePages,
          Settings.urls.rbac.rolePages,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    // ROLE_PERMISSIONS
    role_permissions: {
      label: "Roles & Permissions",
      tableName: "ROLE_PERMISSIONS",
      columns: [
        {
          title: "Role",
          dataIndex: "roleName",
          ...table?.getColumnSearchProps("roleName"),
        },

        {
          title: "Permission",
          dataIndex: "permissionCustomName",
          ...table?.getColumnSearchProps("permissionCustomName"),
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Active",
          dataIndex: "block",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        {
          title: "Open",
          dataIndex: "open",
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.rbac.rolePermissions,
          Settings.urls.rbac.rolePermissions,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    // BUSES
    buses: {
      label: "Buses",
      tableName: "BUSES",
      columns: [
        {
          title: "Bus Number",
          dataIndex: "busNumber",
          ...table?.getColumnSearchProps("busNumber"),
        },

        {
          title: "Registration Number Plate",
          dataIndex: "plateNumber",
          ...table?.getColumnSearchProps("plateNumber"),
        },
        {
          title: "Capacity",
          dataIndex: "capacity",
        },
        {
          title: "Status",
          dataIndex: "status",
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.transport.buses,
          Settings.urls.transport.buses,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //DRIVERS
    drivers: {
      label: "Drivers",
      tableName: "DRIVERS",
      columns: [
        {
          title: `Driver's Name`,
          dataIndex: "driverName",
          ...table?.getColumnSearchProps("driverName"),
        },

        {
          title: "License Number",
          dataIndex: "licenseNumber",
          ...table?.getColumnSearchProps("licenseNumber"),
        },
        {
          title: "License Expiry Date",
          dataIndex: "licenseExpiry",
          ...table?.getColumnSearchProps("licenseExpiry"),
        },
        {
          title: "Status",
          dataIndex: "status",
          // ...table?.getColumnSearchProps('custom_name'),
        },
        actions(
          del,
          Settings.urls.transport.drivers,
          Settings.urls.transport.drivers,
          "driverID",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //ROUTES
    routes: {
      label: "Routes",
      tableName: "ROUTES",
      columns: [
        {
          title: "Name of Route",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },

        {
          title: "Distance (Km)",
          dataIndex: "distanceKm",
        },
        actions(
          del,
          Settings.urls.transport.route,
          Settings.urls.transport.route,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },
    //BUS STOPS
    busstops: {
      label: "Bus Stops",
      tableName: "BUS_STOPS",
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Latitude",
          dataIndex: "latitude",
        },

        {
          title: "Longitude",
          dataIndex: "longitude",
        },
        {
          title: "Distance (Km)",
          dataIndex: "distanceKm",
        },
        actions(
          del,
          Settings.urls.transport.busstop,
          Settings.urls.transport.busstop,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //DRIVER BUS ROUTE
    driverbusroute: {
      label: "Drivers Buses & Route Mapping",
      tableName: "DRIVER_BUS_ROUTE",
      columns: [
        {
          title: `Driver's Name`,
          dataIndex: "driverName",
          ...table?.getColumnSearchProps("driverName"),
        },
        {
          title: "Registration Number Plate",
          dataIndex: "busPlate",
        },
        {
          title: "Capacity",
          dataIndex: "busCapacity",
        },
        {
          title: "Route",
          dataIndex: "routeName",
        },
        {
          title: "Distance",
          dataIndex: "routeDistanceKm",
        },
        actions(
          del,
          Settings.urls.transport.driverbusroute,
          Settings.urls.transport.driverbusroute,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //MY_FUEL_REQUEST
    fuelrequest: {
      label: "Fuel Requests",
      tableName: "FUEL_REQUEST",
      columns: [
        ...fuelRequestColumns(table),
        printCoupon(pdfExport),
        viewAction(
          table,
          Settings.urls.transport.fuelrequests,
          navigate,
          "id",
          setItemToview,
          perms,
        ),
        actions(
          del,
          Settings.urls.transport.fuelrequests,
          Settings.urls.transport.fuelrequests,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    maintenance_request: {
      label: "Maintenance Requests",
      tableName: "MAINTENANCE_REQUEST",
      columns: [
        ...maintRequestColumns(table),
        printRepairJobCard(pdfExport),
        upload(navigate, "Upload Invoice"),
        actions(
          del,
          Settings.urls.transport.repair_requests,
          Settings.urls.transport.repair_requests,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //TRANPORT_TYPES
    transport_types: {
      label: "Transport Types",
      tableName: "TRANPORT_TYPES",
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          ...table?.getColumnSearchProps("name"),
        },
        actions(
          del,
          Settings.urls.transport.transporttype,
          Settings.urls.transport.transporttype,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //TRANPORT_TARIFFS
    tariffs: {
      label: "Transport Fares",
      tableName: "TRANPORT_TARIFFS",
      columns: [
        {
          title: "Type",
          dataIndex: "transportTypeName",
          ...table?.getColumnSearchProps("transportTypeName"),
        },
        {
          title: "Route",
          dataIndex: "routeName",
          ...table?.getColumnSearchProps("routeName"),
        },
        {
          title: "Fares",
          dataIndex: "tariff",
          ...table?.getColumnSearchProps("tariff"),
          render(v, record) {
            return (
              <label className={"text-successx fw-bold"}>
                UGX {Utilities.formatAccounting(v)}
              </label>
            );
          },
        },
        actions(
          del,
          Settings.urls.transport.tariff,
          Settings.urls.transport.tariff,
          "id",
          onEdit,
          onDelete,
          setRerender,
          perms,
        ),
      ]?.filter(Boolean),
    },

    //FUEL_COUPONS
    fuel_coupons: {
      label: "Fuel Coupons",
      tableName: "FUEL_COUPONS",
      columns: [
        {
          title: "Coupon Code",
          dataIndex: "couponCode",
          ...table?.getColumnSearchProps("couponCode"),
        },
        {
          title: "Driver Name",
          dataIndex: "driverName",
          ...table?.getColumnSearchProps("driverName"),
        },
        {
          title: "Registration Number Plate",
          dataIndex: "busPlateNumber",
          ...table?.getColumnSearchProps("busPlateNumber"),
        },
        {
          title: "Date of Issue",
          dataIndex: "issuedAt",
          ...table?.getColumnSearchProps("issuedAt"),
          render(v, record) {
            return Utilities.formatDate(v);
          },
        },
        {
          title: "Expiry",
          dataIndex: "expiryDate",
          ...table?.getColumnSearchProps("expiryDate"),
          render(v, record) {
            return Utilities.formatDate(v);
          },
        },
        {
          title: "Status",
          dataIndex: "status",
          ...table?.getColumnSearchProps("status"),
          render(v, record) {
            return v == "Active" ? (
              <Tag color="green">{v}</Tag>
            ) : v == "Used" ? (
              <Tag color="blue">{v}</Tag>
            ) : (
              <Tag color="red">{v}</Tag>
            );
          },
        },
        {
          title: "Litres",
          dataIndex: "litres",
        },
        printCoupon(pdfExport),
      ]?.filter(Boolean),
    },
  }; //return curl brace block
};

export const fuelApproDeclCols = (
  table,
  endpoint,
  navigate,
  setRecord,
  setItemToview,
  rejectionRemark,
  valuesStore,
  perms,
) => {
  // console.log(Settings.urls.transport.fuelrequests)
  return {
    //FUEL_REQUEST
    fuelrequest: {
      label: "Fuel Requests",
      tableName: "FUEL_REQUEST",
      columns: [
        ...fuelRequestColumns(table),
        Utilities.hasPermissionV2(
          ["GET"],
          perms,
          Settings.urls.transport.fuelrequests,
        ) &&
          viewAction(
            table,
            Settings.urls.transport.fuelrequests,
            navigate,
            "id",
            setItemToview,
            perms,
          ),
        Utilities.hasPermissionV2(["POST", "PUT", "PATCH"], perms, endpoint) &&
          apprvDeclActions(
            table,
            endpoint,
            navigate,
            setRecord,
            "fuelRequestID",
            "id",
            rejectionRemark,
            perms,
          ),
      ].filter(Boolean),
    },
  };
};

export const maintApproDeclCols = (
  table,
  endpoint,
  navigate,
  setRecord,
  setItemToview,
  rejectionRemark,
  valuesStore,
  perms,
) => {
  return {
    //MAINT_REQUEST
    request: {
      label: "Maintenance Requests",
      tableName: "MAINTENANCE_REQUEST",
      columns: [
        ...maintRequestColumns(table),
        Utilities.hasPermissionV2(
          ["GET"],
          perms,
          Settings.urls.transport.repair_requests,
        ) &&
          viewAction(
            table,
            Settings.urls.transport.repair_requests,
            navigate,
            "id",
            setItemToview,
            perms,
          ),
        Utilities.hasPermissionV2(["POST", "PUT", "PATCH"], perms, endpoint) &&
          apprvDeclActions(
            table,
            endpoint,
            navigate,
            setRecord,
            "maintenanceRequestID",
            "id",
            rejectionRemark,
            perms,
          ),
      ].filter(Boolean),
    },
  };
};

export const allMaintRequestsCols = (
  table,
  endpoint,
  navigate,
  setRecord,
  valuesStore,
  perms,
) => {
  return {
    request: {
      label: "All Maintenance Requests",
      tableName: "ALL_MAINTENANCE_REQUEST",
      columns: [
        {
          title: "Number",
          dataIndex: "maintenanceRequestNumber",
          ...table?.getColumnSearchProps("maintenanceRequestNumber"),
        },
        {
          title: `Driver's Name`,
          dataIndex: "driverName",
          ...table?.getColumnSearchProps("driverName"),
        },
        {
          title: "Registration Number Plate",
          dataIndex: "busPlateNumber",
          ...table?.getColumnSearchProps("busPlateNumber"),
        },
        {
          title: "Type",
          dataIndex: "maintenanceType",
          ...table?.getColumnSearchProps("maintenanceType"),
        },
        {
          title: "Issue",
          dataIndex: "issue",
          ...table?.getColumnSearchProps("issue"),
        },
        {
          title: "Status",
          dataIndex: "status",
          ...table?.getColumnSearchProps("status"),
          render(v, record) {
            return v == "Approved" ? (
              <Tag color="green">{v}</Tag>
            ) : v == "Pending Approval" || v == "Verification Pending" ? (
              <Tag color="blue">{v}</Tag>
            ) : (
              <Tag color="red">{v}</Tag>
            );
          },
        },
        {
          title: "Date",
          dataIndex: "createdAt",
          ...table?.getColumnSearchProps("createdAt"),
          render(v, record) {
            return Utilities.formatDate(v);
          },
        },
        Utilities.hasPermissionV2(["GET"], perms, endpoint) &&
          viewAction(table, endpoint, navigate, "id", setRecord, perms),
      ].filter(Boolean),
    },
  };
};

export const allFuelRequestsCols = (
  table,
  endpoint,
  navigate,
  setRecord,
  valuesStore,
  perms,
) => {
  return {
    fuelrequest: {
      label: "All Fuel Requests",
      tableName: "ALL_FUEL_REQUEST",
      columns: [
        {
          title: "Number",
          dataIndex: "requestNumber",
          ...table?.getColumnSearchProps("requestNumber"),
        },
        {
          title: "Coupon Code",
          dataIndex: "couponCode",
          ...table?.getColumnSearchProps("couponCode"),
        },
        {
          title: "Approver",
          dataIndex: "approverName",
          ...table?.getColumnSearchProps("approverName"),
        },
        {
          title: "Comments",
          dataIndex: "comments",
        },
        {
          title: "Level",
          dataIndex: "level",
          ...table?.getColumnSearchProps("level"),
          render(v, record) {
            return v == "L1" ? (
              <Tag color="purple">{v}</Tag>
            ) : v == "L2" ? (
              <Tag color="green">{v}</Tag>
            ) : (
              <Tag color="blue">{v}</Tag>
            );
          },
        },
        {
          title: "Action",
          dataIndex: "action",
          render(v, record) {
            return v == "Rejected" ? (
              <Tag color="red">{v}</Tag>
            ) : v == "Coupon Generated" ? (
              <Tag color="green">{v}</Tag>
            ) : (
              <Tag color="blue">{v}</Tag>
            );
          },
        },
        {
          title: "Exceptional",
          dataIndex: "exceptional",
          filters: [
            {
              text: "Yes",
              value: 1,
            },
            {
              text: "No",
              value: 0,
            },
          ],
          onFilter: (v, record) => {
            return record.exceptional == v;
          },
          render(v, record) {
            return v ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>;
          },
        },
        {
          title: "Approved Date",
          dataIndex: "approvedAt",
          ...table?.getColumnSearchProps("approvedAt"),
          render(v, record) {
            return Utilities.formatDate(v);
          },
        },
        Utilities.hasPermissionV2(["GET"], perms, endpoint) &&
          viewAction(
            table,
            endpoint,
            navigate,
            "fuelRequestID",
            setRecord,
            perms,
          ),
      ]?.filter(Boolean),
    },
  };
};

export default SetupObject;
